const articleViewStyles = {
  articleContainer: {
    borderRadius: 3,
    padding: 18,
    backgroundColor: "white",
  },
  title: {
    fontSize: 27,
    paddingTop: 9,
    paddingBottom: 9,
  },
  postDate: {
    color: "#333333",
    textAlign: "right",
  },
  eyeCatchImg: {},
};
export default articleViewStyles;
